// extracted by mini-css-extract-plugin
export default {"container":"NoPage_container__iGF9w"};